export default "__VITE_ASSET__CxgRE0_5__"